import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './i18n'; // اطمینان از تنظیمات ترجمه
import { TonConnectUIProvider } from '@tonconnect/ui-react';
import { BrowserRouter } from 'react-router-dom';


window.Buffer = window.Buffer || Buffer;
// آدرس فایل مانفیست مینی‌اپ شما
const manifestUrl = 'https://candleduel.xyz/tonconnect-manifest.json';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <TonConnectUIProvider manifestUrl={manifestUrl}>
        <App />
      </TonConnectUIProvider>
    </BrowserRouter>
  </React.StrictMode>
);
